import { post, deleterequest, get } from '../axios'
const api = `${process.env.VUE_APP_AMS_ADMIN}/ams-admin/lottery/activity`

// 活动数据
export function lottery_activity_attendData(map, option) {
  return post(`${api}/attendData`, map, option)
}

// 活动发放明细
export function lottery_activity_attendRecord(map, option) {
  return post(`${api}/attendRecord`, map, option)
}

// 删除活动
export function lottery_activity_delete(map, option) {
  return deleterequest(`${api}/delete`, map, option)
}

// 活动详情
export function lottery_activity_detail(map, option) {
  return get(`${api}/detail`, map, option)
}

// 活动分页列表
export function lottery_activity_pageList(map, option) {
  return post(`${api}/pageList`, map, option)
}

// 保存活动信息
export function lottery_activity_save(map, option) {
  return post(`${api}/save`, map, option)
}

// 生成活动链接
export function lottery_activity_generate_url(map, option) {
  return post(`${api}/generateUrl`, map, option)
}
// 开启/关闭个人中心入口
export function lottery_activity_personal_center(map, option) {
  return post(`${api}/personalCenter`, map, option)
}
// 复制活动
export function lottery_activity_copy(map, option) {
  return post(`${api}/copy`, map, option)
}
